import NiceSelect from '../helpers/nice-select2'
import refs from '../helpers/refs'
import site from '../helpers/site'

class CProductFauxVariant {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    this.site = site()
    if (this.site === 'kamadojoe') {
      // KJ
      this.sizeSelect = new NiceSelect(document.getElementById('fauxSize'), { })
      this.seriesSelect = new NiceSelect(document.getElementById('fauxSeries'), { })
    } else {
      // MB - both are optional
      if (document.getElementById('fauxSize')) {
        this.sizeSelect = new NiceSelect(document.getElementById('fauxSize'), { })
      }
      if (document.getElementById('fauxVariant')) {
        this.variantSelect = new NiceSelect(document.getElementById('fauxVariant'), { })
      }
    }

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.m-product-faux-variant')
    .forEach(el => new CProductFauxVariant(el))
})
